{
  "es": {
    "labels": {
      "true": "Sí",
      "false": "No",
      "null": "-",
      "supporter": {
        "badge": "Patrocinador",
        "tooltip": "Apoya a FleetYards.net este mes"
      },
      "destroyedFleets": {
        "discarded": "Descartada",
        "purged": "Purgada"
      },
      "and": "y",
      "hide": "Ocultar",
      "show": "Mostrar",
      "only": "Solo",
      "description": "Descripción",
      "unavailable": "no disponible",
      "selected": "Seleccionado",
      "actions": "Acciones",
      "status": "Estado",
      "enabled": "Habilitado",
      "disabled": "Deshabilitado",
      "collapse": "Contraer",
      "price": "Precio",
      "expand": "Expandir",
      "distance": "Distancia",
      "anonymous": "Anónimo",
      "toggleNavigation": "Alternar navegación",
      "enableYoutube": "Haz clic para habilitar videos de YouTube o clic derecho para copiar URL del video",
      "openInNewWindow": "Abrir en pantalla completa",
      "or": "o",
      "deselect": "Haz clic para deseleccionar",
      "networkStatusOffline": "Estado de red: Desconectado - Servicio no disponible",
      "groups": "Grupos",
      "classifications": "Clasificaciones",
      "features": {
        "stateOn": "Habilitado",
        "stateOff": "Deshabilitado",
        "stateConditional": "Condicional",
        "selfService": "Autoservicio",
        "selfServiceEnabled": "Los usuarios pueden activar/desactivar esta función",
        "selfServiceDisabled": "Los usuarios no pueden activar/desactivar esta función",
        "actors": "Actores",
        "groups": "Grupos",
        "noGroups": "No hay grupos habilitados para esta función.",
        "noActors": "No hay actores individuales habilitados para esta función.",
        "user": "Usuario",
        "fleet": "Flota",
        "actorType": "Tipo de actor",
        "percentageOfActors": "de actores",
        "percentageOfTime": "del tiempo",
        "currentState": "Estado actual",
        "toggle": "Alternar",
        "settingsIntro": "Habilite o deshabilite funciones experimentales para su cuenta. Estas funciones pueden estar incompletas o cambiar sin previo aviso.",
        "noFeaturesAvailable": "Actualmente no hay funciones de autoservicio disponibles.",
        "descriptions": {
          "tools_travel_times": "Mostrar tiempos de viaje estimados entre ubicaciones.",
          "tools_cargo_grids": "Mostrar visor interactivo de grilla de carga para naves.",
          "fleet_starmap": "Mostrar mapa estelar de Star Citizen en las páginas de miembros de flota."
        },
        "registryHint": "Los flags se declaran en config/feature_flags.yml y se crean al desplegar. Aquí controlas sus puertas de acceso.",
        "fleetSettingsIntro": "Habilite o deshabilite funciones para toda la flota. Todos los miembros ven lo que active aquí.",
        "fleetFeature": "Función de flota",
        "fleetFeatureInfo": "Activarla aquí la habilita solo para usted. Los administradores de su flota pueden habilitarla para toda la flota.",
        "toggleForSelf": "Activar solo para usted",
        "fleetFeatureGrantedShort": "Activado por la flota",
        "fleetFeatureGranted": "Su flota lo activó para todos los miembros, por lo que no se puede desactivar aquí.",
        "groupFeatureGrantedShort": "Activado por el grupo",
        "groupFeatureGranted": "Un grupo al que pertenece tiene esta función activada, por lo que no se puede desactivar aquí.",
        "groupFeatureGrantedFleet": "Un grupo al que pertenece esta flota tiene esta función activada, por lo que no se puede desactivar aquí.",
        "managedFeatureShort": "Gestionado",
        "managedFeature": "Esta función se activó para su cuenta y no se puede cambiar aquí.",
        "managedFeatureFleet": "Esta función se activó para esta flota y no se puede cambiar aquí.",
        "selfServiceUser": "Los usuarios pueden alternar",
        "selfServiceFleet": "Los admins de flota pueden alternar"
      },
      "oauthApplication": {
        "name": "Nombre de la aplicación",
        "clientId": "ID de cliente",
        "clientSecret": "Secreto de cliente",
        "redirectUri": "URI de redirección",
        "redirectUriHint": "Use una URI por línea.",
        "confidential": "Confidencial",
        "scopes": "Alcances",
        "scopesHint": "Si no se seleccionan alcances, se usarán los alcances predeterminados: %{scopes}"
      },
      "rsiRequestLogs": {
        "resolved": "Resuelto",
        "unresolved": "Sin resolver"
      },
      "imports": {
        "type": "Tipo",
        "status": "Estado",
        "version": "Versión",
        "startedAt": "Iniciada",
        "finishedAt": "Finalizada",
        "failedAt": "Falló el",
        "info": "Info",
        "input": "Entrada",
        "output": "Salida",
        "importData": "Datos de importación",
        "file": "Archivo importado",
        "requestedBy": "Solicitada por",
        "adminUser": "Usuario administrador",
        "user": "Usuario",
        "includeSystem": "Incluir sistema",
        "systemRequester": "sistema",
        "statuses": {
          "created": "En cola",
          "started": "En ejecución",
          "finished": "Finalizada",
          "failed": "Fallida"
        }
      },
      "oauthApplications": {
        "settingsIntro": "Administre sus aplicaciones OAuth. Estas aplicaciones pueden acceder a la API de FleetYards en nombre de los usuarios.",
        "name": "Nombre de la aplicación",
        "redirectUri": "URI de redirección",
        "confidential": "Confidencial",
        "clientId": "ID de cliente",
        "clientSecret": "Secreto de cliente",
        "scopes": "Alcances",
        "defaultScopes": "Alcances predeterminados",
        "confidentialShort": "Confidencial",
        "publicShort": "Público"
      },
      "fleetInviteToken": "Invitación de flota",
      "scDataVersion": "Versión del parche",
      "lastReload": "Última recarga",
      "createdAt": "Creado el",
      "updatedAt": "Actualizado el",
      "addToHangar": "Agregar al hangar",
      "home": {
        "search": "Buscar naves..."
      },
      "shop": {
        "rentalPrice": "alquiler",
        "sellPrice": "vende por",
        "buyPrice": "compra por"
      },
      "shopCommodity": {
        "item": "Artículo",
        "shop": "Tienda",
        "sellPrices": "Precios de venta",
        "buyPrices": "Precios de compra",
        "rentalPrices": "Precios de alquiler",
        "confirmed": "¿Confirmado?",
        "submittedBy": "Enviado por",
        "prices": {
          "label": "Precios",
          "rentalPrice": "alquiler",
          "averageRentalPrice": "alquiler (Ø)",
          "sellPrice": "vende por",
          "averageSellPrice": "vende por (Ø)",
          "buyPrice": "compra por",
          "averageBuyPrice": "compra por (Ø)",
          "rentalPrice1Day": "1 día por",
          "averageRentalPrice1Day": "1 día por (Ø)",
          "rentalPrice3Days": "3 días por",
          "averageRentalPrice3Days": "3 días por (Ø)",
          "rentalPrice7Days": "7 días por",
          "averageRentalPrice7Days": "7 días por (Ø)",
          "rentalPrice30Days": "30 días por",
          "averageRentalPrice30Days": "30 días por (Ø)"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Nuevas naves en %{year}",
          "totalShips": "Total de naves",
          "totalMembers": "Total de miembros",
          "vehicles": "Naves en hangar",
          "wishlists": "Naves en lista de deseos",
          "shipOfTheMonth": "Nave del mes"
        },
        "modelsByClassification": "Naves por clasificación",
        "modelsBySize": "Naves por tamaño",
        "vehiclesByModel": "Naves por modelo (Top %{limit})",
        "modelsPerMonth": "Naves por mes",
        "modelsByManufacturer": "Naves por fabricante",
        "modelsByProductionStatus": "Naves por estado de producción",
        "vehiclesPerMonth": "Naves en hangar por mes",
        "topVehiclesByModel": "Top 10 naves en hangar",
        "shipsOfTheMonth": "Nave del mes",
        "crewDeficit": "Déficit de tripulación",
        "crewSurplus": "Excedente de tripulación",
        "membersByRole": "Miembros por rol"
      },
      "roadmap": {
        "selectWeek": "Seleccionar semana",
        "shipRoadmap": "Roadmap de naves",
        "releases": "Lanzamientos",
        "unscheduled": "Sin programar",
        "lastUpdate": "Última actualización",
        "released": "Lanzado",
        "recentlyUpdated": "Actualizado recientemente",
        "committed": "Comprometido",
        "lastVersion": {
          "active": {
            "false": "Elemento eliminado de la hoja de ruta",
            "true": "Elemento re-agregado a la hoja de ruta",
            "decreased": "Item was removed from the Roadmap",
            "increased": "Item was readded to the Roadmap"
          },
          "committed": "Item was marked as committed",
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}",
          "addedToRelease": "Item new in release %{release}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "rsiRoadmap": "RSI Roadmap",
      "unknown": "Desconocido",
      "none": "-",
      "notAvailable": "N/A",
      "unknownModel": "%{slug} Unknown",
      "not-available": "N/A",
      "receiveSaleNotifications": "",
      "publicUrl": "URL pública",
      "name": "Nombre",
      "homepage": "Página principal",
      "discord": "Servidor de Discord",
      "youtube": "Canal de Youtube",
      "twitch": "Canal de Twitch",
      "guilded": "Servidor de Guilded",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "Filtro",
      "taxExcluded": "sin IVA",
      "hangar": "Hangar",
      "public": "Público",
      "hangarStats": "Estadísticas",
      "wishlist": "Lista de deseos",
      "fleetchart": "Gráfico de flota",
      "fleetchartApp": {
        "screenHeight": "Altura de pantalla",
        "viewpoint": "Punto de vista",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "Lateral",
          "top": "Superior",
          "angled": "Angular",
          "front": "Frontal"
        },
        "gridSize": "%{size} metro por cuadrícula",
        "mode": "Modo",
        "modeOptions": {
          "classic": "Clásico",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Estadísticas",
      "hangarMetrics": {
        "total": "Total",
        "totalMoney": "Money Value",
        "totalCredits": "Credits",
        "totalIngameValue": "Valor aUEC del hangar",
        "totalMinCrew": "Tripulación mín.",
        "totalMaxCrew": "Tripulación máx.",
        "totalCargo": "Carga total",
        "largestShip": "Nave más grande",
        "smallestShip": "Nave más pequeña",
        "averagePledgePrice": "Precio promedio de Pledge",
        "flightReady": "Listo para volar",
        "uniqueModels": "Modelos únicos",
        "manufacturerCount": "Fabricantes",
        "missingClassifications": "Roles faltantes",
        "wishlistTotalMoney": "Valor de Pledge de lista de deseos",
        "wishlistTotalCredits": "Valor en juego de lista de deseos"
      },
      "selectModel": "Seleccionar una nave",
      "findModel": "Escribe para buscar una nave",
      "find": "Escribe para buscar",
      "selectUser": "Seleccionar un usuario",
      "findUser": "Escriba para buscar un usuario",
      "selectAdminUser": "Seleccionar un usuario administrador",
      "selectFleet": "Seleccionar una flota",
      "findFleet": "Escriba para buscar una flota",
      "compare": {
        "removeModel": "Eliminar nave",
        "addModel": {
          "nullablePrompt": "Agregar una nave"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "toggleSection": "Alternar %{section}",
        "shipCount": {
          "one": "%{count} nave",
          "other": "%{count} naves"
        },
        "containersOfSize": "Contenedores de %{size} SCU",
        "shieldGenerators": "Generadores de escudo",
        "armorHp": "HP de blindaje",
        "fuelAndQuantum": "Combustible y Quantum",
        "weaponPoolSize": "Reserva de energía de armas",
        "crossSection": {
          "x": "Sección transversal X",
          "y": "Sección transversal Y",
          "z": "Sección transversal Z"
        },
        "useAsBaseline": "Usar como referencia",
        "baseline": "Referencia",
        "differencesOnly": "Solo diferencias",
        "compareToBaseline": "Comparar con la referencia",
        "loadoutBySlot": "Configuración por slot",
        "slots": {
          "guns": "Cañones principales",
          "turrets": "Torretas",
          "missiles": "Misiles",
          "shields": "Generadores de escudo",
          "powerPlants": "Plantas de energía",
          "coolers": "Enfriadores",
          "quantumDrives": "Motores Quantum",
          "thrusters": "Propulsores principales",
          "countermeasures": "Contramedidas"
        },
        "legend": {
          "best": "mejor de la fila",
          "worst": "peor",
          "share": "porcentaje del mejor de la fila",
          "better": "supera la referencia",
          "worse": "por detrás de ella"
        }
      },
      "cargoRoutes": "Rutas de carga",
      "uecPerUnit": "aUEC / Unit",
      "au": "AU",
      "uec": "aUEC",
      "sell": "Vender",
      "buy": "Comprar",
      "yourFlagship": "Su nave insignia",
      "flagship": "Nave insignia",
      "fleet": {
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flota",
        "fid": "ID de flota",
        "name": "Nombre",
        "logo": "Logo",
        "rsiSid": "SID",
        "description": "Descripción",
        "public": "Vista de flota pública",
        "publicFleet": "Flota pública",
        "publicStats": "Estadísticas públicas",
        "publicFleetStats": "Estadísticas de flota públicas",
        "discord": {
          "url": "Servidor de Discord",
          "hint": "Conecta un servidor de Discord para reflejar los eventos como eventos programados nativos. Los miembros pueden confirmar su asistencia desde Discord y la inscripción se sincronizará de vuelta con Fleetyards.",
          "guildId": "ID del servidor de Discord",
          "channelId": "ID del canal de voz (opcional)",
          "webhookUrl": "URL del webhook de anuncios (opcional)",
          "installBotHint": "Abre la página de instalación de Discord en una pestaña nueva — elige el servidor al que quieres reflejar los eventos.",
          "statusOk": "Conectado a %{name}",
          "statusCodes": {
            "missing_token": "El bot de Fleetyards no está configurado en el lado del servidor. Contacta con un administrador.",
            "missing_guild": "Introduce primero un ID de servidor de Discord.",
            "invalid_token": "El token del bot no es válido. Contacta con un administrador.",
            "bot_not_in_guild": "El bot no está en este servidor. Usa el enlace de instalación para añadirlo.",
            "guild_not_found": "Discord no reconoce este ID de servidor. Revisa el valor.",
            "discord_error": "Discord devolvió un error inesperado.",
            "request_failed": "No se pudo contactar con Fleetyards. Inténtalo de nuevo."
          }
        },
        "guilded": "Servidor de Guilded",
        "homepage": "Página principal",
        "twitch": "Canal de Twitch",
        "youtube": "Canal de Youtube",
        "backgroundImage": "Imagen de fondo",
        "ts": "Servidor Teamspeak",
        "awaitingConfirmation": "Esperando confirmación de la flota",
        "members": {
          "primary": "¿Flota principal?",
          "hideShips": "¿Ocultar sus naves para esta flota?",
          "shipsFilter": {
            "label": "¿Qué naves deben agregarse a la flota?",
            "nullablePrompt": "No se seleccionó ninguna opción",
            "field": "Selección de naves",
            "values": {
              "all": "Todas las naves",
              "hangar_group": "Todas las naves en un grupo de hangar dado",
              "hide": "Sin naves"
            }
          },
          "hangarGroupId": {
            "field": "Grupo de hangar",
            "label": "Especifique un grupo de hangar",
            "nullablePrompt": "No se seleccionó ningún grupo"
          },
          "total": "Total: %{count}",
          "joined": "Unido el",
          "invited": "Invitado",
          "invitedAt": "Invitado / Solicitado el",
          "requested": "Membresía solicitada",
          "declined": "Rechazado",
          "pending": "Invitaciones y solicitudes pendientes",
          "accepted": "Miembros",
          "declinedMembers": "Rechazado",
          "role": "Rol",
          "roles": {
            "admin": "Admin",
            "officer": "Oficial",
            "member": "Miembro"
          },
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord"
        },
        "roles": {
          "permanent": "Permanente",
          "privilegeGroups": {
            "fleet": "Flota",
            "memberships": "Miembros",
            "invites": "Invitaciones",
            "vehicles": "Vehículos",
            "roles": "Roles",
            "inventories": "Inventarios",
            "missions": "Misiones",
            "events": "Eventos",
            "notifications": "Notificaciones"
          },
          "privileges": {
            "fleet:update": "Actualizar flota",
            "fleet:update:images": "Actualizar imágenes",
            "fleet:update:description": "Actualizar descripción",
            "fleet:delete": "Eliminar flota",
            "fleet:manage": "Administrar flota",
            "fleet:memberships:read": "Ver miembros",
            "fleet:memberships:create": "Invitar miembros",
            "fleet:memberships:update": "Actualizar miembros",
            "fleet:memberships:delete": "Eliminar miembros",
            "fleet:memberships:manage": "Administrar miembros",
            "fleet:invites:read": "Ver invitaciones",
            "fleet:invites:create": "Crear invitaciones",
            "fleet:invites:update": "Actualizar invitaciones",
            "fleet:invites:delete": "Eliminar invitaciones",
            "fleet:invites:manage": "Administrar invitaciones",
            "fleet:vehicles:read": "Ver vehículos",
            "fleet:vehicles:create": "Agregar vehículos",
            "fleet:vehicles:update": "Actualizar vehículos",
            "fleet:vehicles:delete": "Eliminar vehículos",
            "fleet:vehicles:manage": "Administrar vehículos",
            "fleet:roles:read": "Ver roles",
            "fleet:roles:create": "Crear roles",
            "fleet:roles:update": "Actualizar roles",
            "fleet:roles:delete": "Eliminar roles",
            "fleet:roles:manage": "Administrar roles",
            "fleet:inventories:read": "Ver inventarios",
            "fleet:inventories:create": "Crear inventarios",
            "fleet:inventories:update": "Actualizar inventarios",
            "fleet:inventories:delete": "Eliminar inventarios",
            "fleet:inventories:manage": "Gestionar inventarios",
            "fleet:missions:read": "Ver misiones",
            "fleet:missions:create": "Crear misiones",
            "fleet:missions:update": "Actualizar misiones",
            "fleet:missions:delete": "Eliminar misiones",
            "fleet:missions:manage": "Gestionar misiones",
            "fleet:events:read": "Ver eventos",
            "fleet:events:create": "Crear eventos",
            "fleet:events:update": "Actualizar eventos",
            "fleet:events:delete": "Eliminar eventos",
            "fleet:events:manage": "Gestionar eventos",
            "fleet:notifications:manage": "Gestionar la configuración de notificaciones"
          },
          "name": "Nombre",
          "rank": "Rango"
        },
        "inviteUrls": {
          "noLimit": "No limit",
          "noExpiration": "Never expires",
          "usesLeft": "%{count} uses left",
          "used": "Usado %{count} veces",
          "usedOfLimit": "%{count} de %{limit} usados",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 día",
            "7_days": "7 days"
          },
          "limitOptions": {
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses",
            "infinite": "No limit"
          }
        },
        "calendarSubscription": {
          "intro": "Genera un enlace privado que los miembros pueden usar para suscribirse a los eventos de esta flota desde su aplicación de calendario (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Comparte el enlace de arriba con tus miembros. Ellos lo pegan en su aplicación de calendario (\"Suscribirse al calendario\" o \"Añadir por URL\"). El enlace es privado: cualquiera que lo tenga puede ver los eventos de esta flota."
        },
        "notifications": {
          "inAppHeading": "Notificaciones en la app",
          "inAppHint": "Elige qué cambios del ciclo de vida de los eventos aparecen como notificaciones en la app para los miembros de la flota.",
          "events": {
            "fleet_event": {
              "published": "Evento publicado",
              "locked": "Inscripciones bloqueadas",
              "unlocked": "Inscripciones reabiertas",
              "starting_soon": "El evento empieza pronto",
              "started": "Evento iniciado",
              "completed": "Evento completado",
              "cancelled": "Evento cancelado",
              "archived": "Evento archivado",
              "destroyed": "Evento eliminado"
            },
            "fleet_event_signup": {
              "created": "Inscripción añadida",
              "withdrawn": "Inscripción retirada"
            }
          }
        },
        "inventories": {
          "name": "Nombre",
          "description": "Descripción",
          "location": "Ubicación",
          "visibility": "Visibilidad",
          "manager": "Gestor",
          "itemsCount": "Entradas",
          "visibilities": {
            "members_only": "Solo miembros",
            "officers_only": "Solo oficiales"
          }
        }
      },
      "hangarGroup": {
        "name": "Nombre",
        "color": "Color",
        "sort": "Orden",
        "public": "¿Mostrar en hangar público?"
      },
      "source": "Fuente",
      "loadout": {
        "namePlaceholder": "Nombre de la configuración...",
        "urlPlaceholder": "Pega la URL de una configuración de erkul.games o spviewer.eu...",
        "empty": "Aún no hay configuraciones. Crea una para empezar.",
        "active": "Activa",
        "activate": "Marcar como activa",
        "planOn": "Planifica tu configuración en"
      },
      "model": {
        "hidden": "¿Oculto?",
        "active": "¿Activo?",
        "inGame": "¿En el juego?",
        "adiMap": "¿Mapa ADI?",
        "ground": "¿Vehículo terrestre?",
        "productionNote": "Nota de producción",
        "rsiId": "RSI ID",
        "length": "Longitud",
        "beam": "Manga",
        "height": "Altura",
        "scKey": "SC Key",
        "price": "Precio",
        "pledgePrice": "Precio de Pledge",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Masa",
        "minCrew": "Tripulación mín.",
        "maxCrew": "Tripulación máx.",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Velocidad máx.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Carga",
        "cargoHolds": "Bodegas de carga",
        "hydrogenFuelTankSize": "Tamaño del tanque de hidrógeno",
        "hydrogenFuelTanks": "Tanques de combustible de hidrógeno",
        "quantumFuelTankSize": "Tamaño del tanque Quantum",
        "quantumFuelTanks": "Tanques de combustible Quantum",
        "externalFuelTanks": "Tanques de combustible externos",
        "externalFuelTanksTotal": "Capacidad total",
        "externalFuelTanksCount": "Pods",
        "refuelBoom": "Brazo de repostaje",
        "refuelBoomArm": "Brazo",
        "refuelBoomNozzle": "Boquilla",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Guiñada potenciada",
        "pitchBoosted": "Cabeceo potenciado",
        "rollBoosted": "Balanceo potenciado",
        "variants": "Variantes",
        "manufacturer": "Fabricante",
        "loaners": "Prestados",
        "paints": "Pinturas",
        "modules": "Módulos",
        "modulePackages": "Paquetes de módulos",
        "upgrades": "Kits de mejora",
        "brochure": "Folleto",
        "holo": "Holo",
        "angledView": "Vista angular",
        "angledViewColored": "Vista angular a color",
        "sideView": "Vista lateral",
        "sideViewColored": "Vista lateral a color",
        "frontView": "Vista frontal",
        "frontViewColored": "Vista frontal a color",
        "topView": "Vista superior",
        "topViewColored": "Vista superior a color",
        "onSale": "En venta",
        "playerOwnable": "¿Adquirible por jugadores?",
        "salesPage": "Página de venta",
        "addons": "Módulos y kits de mejora",
        "storeImage": "Imagen de tienda",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Posiciones de tripulación",
        "needsCuration": "Necesita curación",
        "curatedPosition": "Posición curada manualmente",
        "baseModel": "Modelo base",
        "fleetchartOffsetLength": "Desfase de longitud del gráfico de flota",
        "fleetchartOffsetBeam": "Desfase de manga del gráfico de flota",
        "extendedLength": "Longitud extendida",
        "extendedBeam": "Manga extendida",
        "extendedHeight": "Altura extendida",
        "extendedFleetchartOffsetLength": "Desplazamiento de longitud extendida del diagrama de flota",
        "extendedFleetchartOffsetBeam": "Desplazamiento de manga extendida del diagrama de flota",
        "defaultHolo": "Holo por defecto",
        "extendedHolo": "Holo extendido",
        "extendedTopView": "Vista superior extendida",
        "extendedTopViewColored": "Vista superior extendida en color",
        "extendedSideView": "Vista lateral extendida",
        "extendedSideViewColored": "Vista lateral extendida en color",
        "extendedFrontView": "Vista frontal extendida",
        "extendedFrontViewColored": "Vista frontal extendida en color",
        "extendedAngledView": "Vista en ángulo extendida",
        "extendedAngledViewColored": "Vista en ángulo extendida en color",
        "state": {
          "retracted": "Retraído",
          "extended": "Extendido"
        },
        "productionStatus": {
          "in-production": "En producción",
          "in-concept": "En concepto",
          "ready": "Listo para hangar",
          "flight-ready": "Listo para volar",
          "announced": "Anunciado"
        },
        "scIdentifier": "SC Identifier"
      },
      "models": {
        "extraColumns": "Columnas",
        "table": {
          "columns": {
            "storeImage": "Imagen",
            "storeImageWide": "Imagen ancha",
            "rsiStoreImage": "Imagen RSI",
            "rsiStoreImageWide": "Imagen RSI ancha",
            "angledView": "Imagen 3D",
            "angledViewWide": "Imagen 3D ancha",
            "rsiId": "RSI ID",
            "hidden": "Oculto",
            "active": "Activo",
            "createdAt": "Creado el",
            "updatedAt": "Actualizado el",
            "manufacturerName": "Fabricante",
            "length": "Longitud",
            "beam": "Manga",
            "height": "Altura",
            "mass": "Masa",
            "cargo": "Carga",
            "quantumFuelTankSize": "Combustible Quantum",
            "hydrogenFuelTankSize": "Combustible de hidrógeno",
            "minCrew": "Tripulación",
            "maxCrew": "Tripulación máx.",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Velocidad máx.",
            "groundMaxSpeed": "Velocidad terrestre",
            "focus": "Enfoque",
            "productionStatus": "Estado de producción",
            "price": "Precio",
            "pledgePrice": "Precio de Pledge"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Niveles",
        "views": "Vistas",
        "base": "Base",
        "crew": "Tripulación",
        "speed": "Velocidad",
        "cargo": "Carga",
        "combat": "Combate",
        "hardpoints": "Puntos de montaje",
        "missileOptions": "Opciones de misiles (si disponibles)",
        "topView": "Top View"
      },
      "flight": {
        "title": "Vuelo",
        "scm": "crucero de combate",
        "nav": "crucero",
        "boost": "Boost",
        "boostSub": "postquemador",
        "reverse": "Marcha atrás",
        "maneuverability": "Maniobrabilidad",
        "fuel": "Combustible",
        "fuelHydrogen": "Hidrógeno",
        "fuelQuantum": "Quantum",
        "hint": "El manejo con boost escala con los pips del motor; todo queda a cero cuando el motor no tiene energía."
      },
      "base": {
        "price": "Precio",
        "priceInGame": "En el juego",
        "pricePledge": "Pledge",
        "availability": "Disponibilidad"
      },
      "availability": {
        "title": "Disponibilidad",
        "buy": "Comprar",
        "rent": "Alquilar",
        "cheapest": {
          "buy": "Compra más barata",
          "rent": "Alquiler más barato"
        },
        "locations": {
          "one": "%{count} ubicación",
          "other": "%{count} ubicaciones"
        },
        "empty": "No se conocen ubicaciones de compra ni de alquiler.",
        "timeRange": {
          "1-day": "1 día",
          "3-days": "3 días",
          "7-days": "7 días",
          "30-days": "30 días"
        }
      },
      "cargo": {
        "title": "Carga",
        "holdsSub": "en %{count} bodegas",
        "maxContainerSub": "la caja más grande que cabe",
        "containers": "Capacidad de contenedores",
        "hint": "Número máximo de contenedores de cada tamaño que caben en las grillas de carga; la barra muestra qué parte de la capacidad total ocupan."
      },
      "fuelTanks": {
        "capacitySub": "en %{count} pods",
        "podsSub": "montajes externos",
        "components": "Tipos de pod",
        "perPod": "por pod",
        "hint": "Combustible transportado en pods montados en puntos de montaje externos; la barra muestra la parte de la capacidad total que aporta cada tipo."
      },
      "refuelBoom": {
        "fuelFlowSub": "transferencia de hidrógeno",
        "quantumFlowSub": "transferencia de quantum",
        "captureRadiusSub": "tolerancia de acoplamiento",
        "equipment": "Equipamiento",
        "hint": "Tasas de transferencia del brazo de repostaje y tolerancia de acoplamiento de su boquilla."
      },
      "combat": {
        "title": "Combate",
        "dps": "DPS de ráfaga",
        "dpsSub": "%{count} armas",
        "sustained": "DPS sostenido",
        "sustainedSub": "con regeneración y calor",
        "alpha": "Alpha",
        "alphaSub": "por descarga",
        "weapons": "Armas",
        "missileDamage": "Daño de misiles",
        "composition": "Composición del daño",
        "damagePhysical": "Físico",
        "damageEnergy": "Energía",
        "damageDistortion": "Distorsión",
        "damageThermal": "Térmico",
        "hint": "DPS de la configuración por defecto. El sostenido tiene en cuenta la regeneración de la reserva de energía de cada arma y su ciclo de sobrecalentamiento. Los misiles quedan excluidos."
      },
      "power": {
        "title": "Distribución de energía",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Restablecer",
        "auto": "Auto",
        "aimAssist": "Asistencia de puntería",
        "cooling": "Refrigeración",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Haz clic para cambiar de eje (x / y / z)",
        "segmentsUsed": "%{used} / %{total} segmentos",
        "hint": "Reparte la energía entre los sistemas. El DPS sostenido de las armas escala con la energía que reciben; el resto se equilibra automáticamente.",
        "families": {
          "weapon": "Armas",
          "shield": "Escudos",
          "engine": "Motor",
          "radar": "Radar",
          "coolers": "Enfriadores",
          "qdrive": "Motor Quantum",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Soporte vital",
          "miningLaser": "Láser de minería",
          "salvage": "Salvamento",
          "tractorBeam": "Rayo tractor",
          "towingbeam": "Rayo de remolque"
        }
      },
      "defense": {
        "title": "Defensa",
        "shieldHp": "HP de escudo",
        "shieldHpSub": "%{count} generadores",
        "shieldRegen": "Regeneración",
        "shieldResistances": "Resistencia",
        "shieldAbsorption": "Absorción",
        "armor": "Blindaje",
        "deflection": "Deflexión",
        "armorReduction": "Reducción de daño",
        "armorSelfResistance": "Autorresistencia",
        "armorSignature": "Firma",
        "damageType": {
          "physical": "Fís",
          "energy": "Energía",
          "distortion": "Distors",
          "thermal": "Térmico"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "Valores de escudo y blindaje de la configuración por defecto. Una absorción inferior al 100 % significa que ese tipo de daño alcanza el casco incluso con los escudos activos.",
        "openDeflectionCheck": "Comprobación de deflexión"
      },
      "deflectionCheck": {
        "title": "Comprobación de deflexión",
        "intro": "— ¿qué cañones perforan sus defensas?",
        "noArmor": "Esta nave no lleva blindaje, así que no se desvía nada.",
        "allSizes": "Todos",
        "deflected": "desviados",
        "pierce": "perforan",
        "weapon": "Arma",
        "boundary": "Umbral de deflexión",
        "alpha": "Alpha",
        "threshold": "Umbral superado",
        "absorbed": "absorbidos",
        "versus": "vs",
        "hoverHint": "Pasa el cursor sobre un arma para ver el desglose por tipo.",
        "note": "El alpha se compara por proyectil, después de la absorción del escudo: un cañón perfora cuando supera la deflexión en algún tipo de daño. Los tipos que los escudos absorben por completo nunca llegan al blindaje, por lo que se listan como absorbidos en lugar de desviados: los detiene el escudo, no el casco. La absorción del escudo se interpola dentro de su rango mín.–máx. publicado según la salud del escudo, y la deflexión del blindaje escala linealmente con la salud del blindaje. Los rayos láser quedan excluidos: causan daño continuo, así que no hay un alpha por disparo que comprobar.",
        "margin": "Margen",
        "reachesArmor": "Llega al blindaje",
        "stoppedByShields": "El escudo lo absorbe",
        "verdict": {
          "absorbed": "Absorbido",
          "deflected": "Desviado",
          "pierces": "Perforado"
        },
        "shieldHealth": "Salud del escudo",
        "armorHealth": "Salud del blindaje",
        "absorb": "Absorc.",
        "defl": "Defl",
        "type": "Tipo",
        "size": "Tamaño"
      },
      "hull": {
        "category": {
          "vital": "Vitales",
          "secondary": "Secundarias",
          "breakable": "Rompibles",
          "subpart": "Subpiezas",
          "cosmetic": "Cosméticas"
        },
        "composition": "Composición del casco",
        "door": "Puerta",
        "doors": "Puertas",
        "doorsNote": "Las puertas interiores rompibles son un apartado aparte: tienen su propia salud y no forman parte de los HP del casco.",
        "doorsSub": "%{count} rompibles",
        "hint": "Los HP del casco son la suma de la salud de todas las piezas.",
        "hullHp": "HP del casco",
        "hullHpSub": "total de todas las piezas",
        "integrity": "Integridad del casco",
        "noHp": "sin HP",
        "parts": "Piezas del casco",
        "partsNote": "Las piezas se ordenan por salud; las piezas cosméticas (puertas, escaleras, aletas) no tienen salud propia. Los archivos del juego no exponen vínculos padre/hijo, así que esto es una lista plana y no un árbol estructural.",
        "partsSub": "en %{count} categorías",
        "partsTree": "Piezas · damageMax",
        "showParts": "Mostrar piezas del casco",
        "title": "Casco",
        "totalHp": "HP total del casco"
      },
      "manufacturer": {
        "longName": "Nombre completo",
        "code": "Código",
        "logo": "Logo",
        "logoOverridden": "Logo (sobrescrito)",
        "icon": "Icono (archivos del juego)",
        "iconOverridden": "Icono (sobrescrito)",
        "scRef": "SC Ref"
      },
      "fundingGoal": {
        "title": "Título",
        "description": "Descripción",
        "amount": "Importe",
        "currency": "Moneda",
        "effectiveFrom": "Vigente desde",
        "endedAt": "Finalizado el"
      },
      "supporterContribution": {
        "name": "Nombre del patrocinador",
        "user": "Cuenta vinculada",
        "amount": "Importe",
        "currency": "Moneda",
        "anonymous": "Anónima",
        "recurring": "Recurrente",
        "startedAt": "Iniciada el",
        "endedAt": "Finalizada el",
        "note": "Nota interna",
        "stats": {
          "total": "Total",
          "count": "Aportaciones",
          "currentMonth": "Este mes",
          "currentMonthCount": "%{count} aportaciones",
          "recurringCount": "Recurrentes",
          "anonymousCount": "Anónimas"
        },
        "chart": {
          "contributions": "Aportaciones",
          "goal": "Objetivo"
        }
      },
      "itemPrice": {
        "price": "Precio",
        "location": "Ubicación",
        "locationUrl": "URL de ubicación"
      },
      "video": {
        "url": "URL",
        "videoType": "Tipo"
      },
      "modelModule": {
        "name": "Nombre",
        "description": "Descripción",
        "price": "Precio",
        "pledgePrice": "Precio Pledge",
        "productionStatus": "Estado de Producción",
        "scKey": "SC Key",
        "storeImage": "Imagen de Tienda",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "dock": {
        "name": "Nombre",
        "dockType": "Tipo de muelle",
        "shipSize": "Tamaño de nave"
      },
      "modelPosition": {
        "name": "Nombre",
        "positionType": "Tipo de posición",
        "source": "Fuente",
        "position": "Orden",
        "types": {
          "pilot": "Piloto",
          "copilot": "Copiloto",
          "turret_gunner": "Artillero de torreta",
          "engineer": "Ingeniero",
          "gunner": "Artillero",
          "loadmaster": "Jefe de carga",
          "passenger": "Pasajero",
          "operator": "Operador",
          "custom": "Personalizada"
        }
      },
      "modelHardpoint": {
        "name": "Nombre",
        "key": "Clave",
        "source": "Fuente",
        "group": "Grupo",
        "hardpointType": "Tipo",
        "size": "Tamaño",
        "category": "Categoría",
        "subCategory": "Subcategoría",
        "details": "Detalles",
        "mount": "Montaje",
        "itemSlots": "Ranuras de objetos",
        "loadoutIdentifier": "Identificador de configuración"
      },
      "modelHardpointLoadout": {
        "name": "Nombre"
      },
      "modelUpgrade": {
        "name": "Nombre",
        "description": "Descripción",
        "pledgePrice": "Precio de Pledge",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "modelModulePackage": {
        "name": "Nombre",
        "description": "Descripción",
        "pledgePrice": "Precio de Pledge",
        "modules": "Módulos",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotación (°)"
      },
      "modelLoaner": {
        "hidden": "¿Oculto?",
        "loanerModel": "Modelo prestado"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "¿Oculto?",
        "active": "¿Activo?",
        "onSale": "En venta",
        "pledgePrice": "Precio de Pledge",
        "productionStatus": "Estado de producción",
        "productionNote": "Nota de producción",
        "copyHint": "Selecciona la nave de destino a la que copiar esta pintura. Los datos de la pintura no se modifican durante la copia.",
        "bulkCopyHint": "Selecciona la nave de destino a la que copiar estas %{count} pinturas. Los datos de las pinturas no se modifican durante la copia.",
        "copySameModel": "La nave de destino debe ser distinta de la nave de origen."
      },
      "component": {
        "size": "Size: %{size}",
        "grade": "Grado",
        "hidden": "¿Oculto?",
        "componentClass": "Clase de componente",
        "componentType": "Tipo de componente",
        "componentSubType": "Subtipo de componente",
        "itemType": "Tipo de objeto",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "hardpoint": {
        "legend": {
          "headline": "Leyenda",
          "slotTaken": "Slot ocupado",
          "slotAvailable": "Slot disponible"
        },
        "size": "Tamaño",
        "rackSize": "Tamaño de rack",
        "details": "Detalles",
        "group": "Grupo",
        "thrusters": {
          "thrust": "Empuje",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix"
          }
        },
        "refuelBoom": {
          "captureRadius": "Radio de captura",
          "fuelFlowRate": "Caudal de combustible",
          "quantumFuelFlowRate": "Caudal de combustible Quantum"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "DPS de ráfaga",
          "sustainedDps": "DPS sostenido",
          "efficiency": "Eficiencia",
          "penetration": "Penetración",
          "fireRate": "Cadencia de tiro",
          "speed": "Velocidad",
          "range": "Alcance",
          "ammo": "Munición",
          "ammoCost": "Coste de munición",
          "pool": "Reserva de energía",
          "maxRegen": "Regen máx./s",
          "costPerShot": "Energía/disparo",
          "heatPerShot": "Calor/disparo",
          "heatPerSecond": "Calor/s",
          "chargeTime": "Tiempo de carga",
          "fullDamageRange": "Alcance DMG máx.",
          "zeroDamageRange": "Alcance DMG nulo",
          "damagePhysical": "Físico",
          "damageEnergy": "Energía",
          "damageDistortion": "Distorsión",
          "damageThermal": "Térmico"
        },
        "missiles": {
          "damage": "Daño",
          "speed": "Velocidad",
          "range": "Alcance",
          "lockRange": "Alcance de fijación",
          "lockTime": "Tiempo de fijación",
          "trackingSignal": "Rastreo"
        },
        "tractorBeams": {
          "maxForce": "Fuerza máx.",
          "minForce": "Fuerza mín.",
          "range": "Alcance",
          "cone": "Cono",
          "tetherBreak": "Ruptura de amarre",
          "cargoForce": "Fuerza de carga",
          "cargoRange": "Alcance de carga",
          "towForce": "Fuerza de remolque",
          "towDistance": "Alcance de remolque",
          "quantumTowMass": "Límite de masa QT",
          "rotationSpeed": "Rotación",
          "moveSpeed": "Velocidad de movimiento"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Tiempo de regen",
          "downedRegenDelay": "Retardo tras caída",
          "damagedRegenDelay": "Retardo tras daño",
          "resistancePhysical": "Resist. fís.",
          "resistanceEnergy": "Resist. energía",
          "resistanceDistortion": "Resist. distors."
        },
        "coolers": {
          "coolingRate": "Refrigeración"
        },
        "powerPlants": {
          "output": "Potencia",
          "pips": "Pips"
        },
        "quantumDrives": {
          "speed": "Velocidad",
          "range": "Alcance",
          "fuelConsumption": "Consumo",
          "spoolUpTime": "Preparación",
          "cooldownTime": "Enfriamiento",
          "splineSpeed": "Órbita",
          "accel": "Acel."
        },
        "jumpDrives": {
          "fuelEfficiency": "Eficiencia de combustible",
          "alignRate": "Tasa de alineación",
          "tuneRate": "Tasa de sintonía",
          "alignDecay": "Decaimiento de alineación",
          "tuneDecay": "Decaimiento de sintonía"
        },
        "radar": {
          "aimAssistRange": "Alcance de asistencia",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS"
        },
        "armor": {
          "hp": "HP",
          "physical": "Físico",
          "energy": "Energía",
          "distortion": "Distorsión",
          "thermal": "Térmico",
          "deflectPhysical": "Defl. fís.",
          "deflectEnergy": "Defl. energía",
          "selfPhysical": "Autorres. fís.",
          "selfEnergy": "Autorres. energía"
        },
        "fuelIntakes": {
          "pushRate": "Tasa de empuje",
          "minRate": "Tasa mín."
        },
        "sources": {
          "game_files": "Archivos del juego",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "Vista",
          "compact": "Compacta",
          "expanded": "Expandida"
        },
        "fuelTanks": {
          "hydrogen": "Tanque de combustible de hidrógeno",
          "quantum": "Tanque de combustible Quantum"
        },
        "jumpDrive": "Motor de salto",
        "maxContainerSize": "Tamaño máx. de contenedor",
        "groups": {
          "avionic": "Aviónica",
          "system": "Sistemas",
          "propulsion": "Propulsión",
          "thruster": "Propulsor",
          "weapon": "Armas",
          "defense": "Defensa",
          "other": "Otros",
          "auxiliary": "Auxiliar",
          "seat": "Asientos",
          "external_fuel_tank": "Tanques de combustible externos",
          "refuel_boom": "Brazo de repostaje"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computadoras",
          "power_plants": "Plantas de energía",
          "coolers": "Enfriadores",
          "shield_generators": "Generadores de escudo",
          "fuel_intakes": "Tomas de combustible",
          "fuel_tanks": "Tanques de combustible",
          "quantum_drives": "Motores Quantum",
          "jump_modules": "Módulos de salto",
          "jumpdrive": "Módulos de salto",
          "quantum_fuel_tanks": "Tanques de combustible Quantum",
          "main_thrusters": "Propulsores principales",
          "maneuvering_thrusters": "Propulsores de maniobra",
          "weapons": "Armas",
          "turrets": "Torretas",
          "missiles": "Misiles",
          "utility_items": "Objetos de utilidad",
          "utility": "Objetos de utilidad",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Seleccionar módulo —",
        "selectModule": "Seleccionar módulo",
        "clearModule": "Borrar selección",
        "categories": {
          "radar": "Radar",
          "armor": "Blindaje",
          "relay": "Relé",
          "countermeasures": "Contramedidas",
          "lifesupport": "Soporte vital",
          "selfdestruct": "Autodestrucción",
          "batteries": "Baterías",
          "computers": "Computadoras",
          "powerplant": "Plantas de energía",
          "cooler": "Enfriadores",
          "module": "Módulos",
          "shieldgenerator": "Generadores de escudo",
          "fuel_intakes": "Tomas de combustible",
          "fueltanks": "Tanques de combustible",
          "external_fuel_tanks": "Tanques de combustible externos",
          "refuel_boom": "Brazo de repostaje",
          "quantumdrive": "Motores Quantum y módulos de salto",
          "jump_modules": "Módulos de salto",
          "jumpdrive": "Módulos de salto",
          "quantum_fuel_tanks": "Tanques de combustible Quantum",
          "main_thrusters": "Propulsores principales",
          "maneuvering_thrusters": "Propulsores de maniobra",
          "retro_thrusters": "Propulsores retro",
          "vtol_thrusters": "Propulsores VTOL",
          "weapons": "Armas",
          "weapon_mounts": "Soportes de armas",
          "turret": "Torretas",
          "missiles": "Misiles",
          "missile_racks": "Racks de misiles",
          "utility_items": "Objetos de utilidad",
          "utility": "Objetos de utilidad",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Estación de llenado de salvamento",
          "cargogrid": "Grilla de carga",
          "seat": "Asientos"
        }
      },
      "blank": {
        "propulsion": "Sin propulsión presente",
        "ordnance": "Sin armamento presente",
        "modular": "Sin módulo presente",
        "avionics": "Sin aviónica presente",
        "fleetInvites": "Sin invitaciones presentes",
        "shopCommodities": "No hay mercancías disponibles",
        "userShips": "Your Hangar is currently Empty. To Add Ships / Vehicles to Your Hangar click the following Icon on Any Ship in the Database:"
      },
      "user": {
        "rsiHandle": "Handle",
        "rsiHandleVerified": "Verificado mediante Citizen iD",
        "location": "Ubicación",
        "currentSystem": "Sistema estelar actual",
        "tester": "¿Tester?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Correo electrónico no confirmado",
        "saleNotify": "Deseo recibir notificaciones de ventas",
        "publicHangar": "Hangar público habilitado",
        "publicHangarLoaners": "Mostrar indicación de préstamos en hangar público",
        "publicHangarStats": "Estadísticas de hangar público habilitadas",
        "publicWishlist": "Lista de deseos pública habilitada",
        "hideOwner": "Ocultar propiedad para flotas",
        "tracking": "Permitir analíticas de uso anónimas",
        "lastActiveAt": "Última actividad",
        "confirmedAt": "Confirmado el",
        "dateFormat": "Formato de fecha",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        }
      },
      "adminUser": {
        "superAdmin": "Super administrador",
        "passwordConfirmation": "Confirmación de contraseña"
      },
      "vehicle": {
        "name": "Nombre",
        "states": "Estados",
        "serial": "Serie",
        "owner": "comandado por",
        "flagship": "Nave insignia",
        "wanted": "Deseado",
        "loaner": "Prestado",
        "bundled": "Incluida en un paquete",
        "bundledWith": "Incluida con %{parent}",
        "public": "Visible públicamente",
        "fullPublic": "Visible públicamente incluyendo nombre",
        "publicShort": "Público",
        "nameVisible": "Visible públicamente",
        "saleNotify": "Deseo recibir notificaciones de ventas",
        "hangarGroups": "Grupos",
        "selectGroup": "Seleccionar un grupo",
        "modelPaintSelect": {
          "nullablePrompt": "Seleccionar una pintura",
          "label": "Pintura"
        },
        "bulkGroupEdit": {
          "hint": "¡Los grupos existentes serán reemplazados!"
        },
        "hasLoaners": "Prestados",
        "boughtViaSelect": {
          "label": "Comprado mediante"
        }
      },
      "image": {
        "active": "¿Activo?",
        "background": "¿Usar como fondo?",
        "caption": "Descripción",
        "enabled": "¿Habilitado?",
        "file": "Archivo de imagen",
        "global": "¿Global?",
        "delete": "Eliminar",
        "start": "Iniciar",
        "cancel": "Cancelar",
        "processing": "Procesando...",
        "error": "Error",
        "name": "Nombre",
        "size": "Tamaño de archivo",
        "dropzone": "Soltar imágenes aquí",
        "cancelUpload": "Cancelar subida",
        "startUpload": "Iniciar subida",
        "selectImages": "Agregar imágenes...",
        "selectFolder": "Agregar una carpeta..."
      },
      "signup": {
        "link": "¿No tiene una cuenta?",
        "privacyPolicy": "Al crear una cuenta en FleetYards, acepta nuestra"
      },
      "privacyPolicy": "Política de privacidad",
      "login": "Nombre de usuario o correo electrónico",
      "username": "Nombre de usuario",
      "twoFactorCode": "Código de dos factores",
      "confirmationCode": "Código de confirmación",
      "email": "Correo electrónico",
      "avatar": "Avatar",
      "alreadyRegistered": "¿Ya tiene una cuenta?",
      "currentPassword": "Contraseña actual",
      "password": "Contraseña",
      "passwordConfirmation": "Confirmación de contraseña",
      "rememberMe": "Recordarme",
      "emptyList": "No hay %{name} presente",
      "all": "Todos",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "Genera un enlace privado para añadir los eventos a los que te has inscrito a tu aplicación de calendario personal (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Pega el enlace en tu aplicación de calendario en \"Suscribirse al calendario\" o \"Añadir por URL\". Cualquiera que tenga este enlace puede ver los eventos a los que estás inscrito: mantenlo en privado."
        }
      },
      "filters": {
        "components": {
          "name": "Nombre",
          "itemType": "Tipo de objeto",
          "componentClass": "Clase de componente",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?"
        },
        "shops": {
          "name": "Nombre",
          "type": "Tipo",
          "celestialObject": "Objeto celeste",
          "model": "Nave",
          "equipment": "Equipamiento",
          "component": "Componente",
          "commodity": "Mercancía",
          "commodityType": "Tipo de mercancía",
          "starsystem": "Sistema estelar",
          "station": "Estación"
        },
        "shopCommodities": {
          "commodityType": "Tipo de mercancía",
          "station": "Estación",
          "shopId": "Tienda",
          "equipment": "Equipamiento",
          "component": "Componente",
          "componentItemTypeFilter": "Component Item Types",
          "equipmentItemTypeFilter": "Equipment Item Types",
          "equipmentTypeFilter": "Tipo de equipamiento",
          "equipmentSlotFilter": "Equipment Slot",
          "commodity": "Mercancía",
          "model": "Nave",
          "name": "Nombre"
        },
        "shopItems": {
          "category": "Categoría",
          "subCategory": "Subcategoría",
          "name": "Nombre",
          "manufacturer": "Fabricante",
          "minPrice": "min. Price",
          "maxPrice": "max. Price"
        },
        "stations": {
          "name": "Nombre",
          "celestialObject": "Objeto celeste",
          "starsystem": "Sistema estelar",
          "type": "Tipo de estación",
          "shops": "Tiendas",
          "docks": "Muelles",
          "habs": "¿Habitación?",
          "cargoHub": "¿Centro de carga?",
          "refinery": "¿Estación de refinería?"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Precio <=",
          "priceGt": "Precio >=",
          "wanted": "Deseado",
          "hidden": "Oculto",
          "public": "Público",
          "group": "Grupo",
          "loaner": "Prestados",
          "bundled": "Snub Crafts incluidos en un paquete",
          "boughtVia": "¿Comprado mediante?"
        },
        "tradeRoutes": {
          "sortBy": "Sort by",
          "sortByValues": {
            "percent": "Max. Percent",
            "profit": "Max. Profit"
          },
          "cargoShip": "With Cargoship?",
          "origin": "From?",
          "destination": "To?",
          "excludeCommodityType": "Exclude Commodity Type",
          "originCelestialObject": "Origin Celestial Object",
          "destinationCelestialObject": "Destination Celestial Object",
          "originStarsystem": "Origin Starsystem",
          "destinationStarsystem": "Destination Starsystem"
        },
        "models": {
          "name": "Nombre",
          "shipRole": "Rol de nave",
          "classification": "Clasificación",
          "focus": "Enfoque",
          "manufacturer": "Fabricante",
          "onSale": "En venta",
          "size": "Tamaño",
          "dockSize": "Tamaño de muelle",
          "price": "Precio",
          "pledgePrice": "Precio de Pledge",
          "productionStatus": "Estado de producción",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Precio <=",
          "priceGt": "Precio >=",
          "willItFit": "Will it Fit?",
          "withCargo": "¿Con carga?",
          "scKeyBlank": "¿Sin SC Key?",
          "positionsNeedCuration": "¿Posiciones que necesitan curación?",
          "fleetchartImageBlank": "¿Sin imagen de gráfico de flota?",
          "holoBlank": "¿Sin Holo?",
          "frontViewBlank": "¿Sin imagen de vista frontal?",
          "topViewColoredBlank": "¿Sin imagen de vista superior a color?",
          "scIdentifierBlank": "¿Sin identificador SC?"
        },
        "modelModules": {
          "name": "Nombre"
        },
        "manufacturers": {
          "name": "Nombre",
          "withModels": "Con modelos",
          "logoBlank": "Sin logo"
        },
        "supporterContributions": {
          "name": "Buscar por nombre",
          "recurring": "Recurrente",
          "anonymous": "Anónima",
          "startedAtGteq": "Iniciada desde",
          "startedAtLteq": "Iniciada hasta",
          "user": "Cuenta vinculada",
          "linked": "Vínculo de cuenta",
          "linkedOnly": "Vinculada",
          "unlinkedOnly": "Sin vincular"
        },
        "adminNotifications": {
          "search": "Buscar"
        },
        "images": {
          "station": "Estación",
          "model": "Nave"
        },
        "users": {
          "search": "Buscar",
          "username": "Nombre de usuario",
          "email": "Correo electrónico",
          "rsiHandle": "Handle de RSI"
        },
        "fleets": {
          "name": "Nombre",
          "fid": "FID",
          "member": "Miembro",
          "members": {
            "role": "Rol",
            "state": "Estado",
            "acceptedAtGt": "Unido desde",
            "acceptedAtLt": "Unido hasta",
            "invitedAtGt": "Invitado desde",
            "invitedAtLt": "Invitado hasta",
            "requestedAtGt": "Solicitado desde",
            "requestedAtLt": "Solicitado hasta",
            "declinedAtGt": "Rechazado desde",
            "declinedAtLt": "Rechazado hasta"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "Buscar objetos..."
          }
        },
        "manufacturer": "Fabricante",
        "commodities": {
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Equipment Type",
          "itemType": "Item Type",
          "weaponClass": "Weapon Class",
          "slot": "Slot",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?"
        },
        "notifications": {
          "search": "Buscar"
        }
      },
      "station": {
        "docks": "Muelles",
        "location": "Ubicación",
        "type": "Tipo",
        "habitation": "Habitación",
        "habs": "Habitaciones",
        "shops": "Tiendas",
        "locationPrefix": {
          "default": "on",
          "asteriod": "on asteroid near",
          "orbit": "in orbit around"
        },
        "locationSuffix": "near %{location}"
      },
      "tradeRoutes": {
        "buy": "Buy for: %{uec}",
        "sell": "Sell for: %{uec}",
        "cargoShip": "for %{cargo} SCU",
        "sortByPercent": "Sort by Percent",
        "sortByProfit": "Sort by Profit",
        "sortByStation": "Sort by Station",
        "showAveragePrices": "Display average Prices",
        "showLatestPrices": "Display latest Prices"
      },
      "hardpoints": {
        "prefix": "Probar configuraciones con",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Métricas basadas en las fórmulas de"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Seleccionar una nave"
      },
      "addAddon": {
        "nullablePrompt": ""
      },
      "table": {
        "selected": "%{count} seleccionados"
      },
      "commodityPrice": {
        "shopId": "Tienda",
        "station": "Estación",
        "commodityItemType": "Tipo de mercancía",
        "commodityItemId": "Artículo de mercancía",
        "item": "ShopCommodity",
        "price": "Precio",
        "type": "Tipo",
        "shop": "Tienda",
        "submittedBy": "Enviado por"
      },
      "syncExtension": {
        "warnings": "Avisos",
        "status": {
          "started": "Importación iniciada...",
          "finished": "Importación finalizada",
          "failed": "¡Importación fallida!"
        },
        "processSteps": {
          "fetchHangar": "Obteniendo datos del hangar RSI",
          "submitData": "Enviando datos al backend de Fleetyards.net"
        },
        "sessionStatus": "Estado de sesión RSI",
        "checkIdentity": "Verificar sesión RSI",
        "identityStatus": {
          "pending": "Comprobando...",
          "notFound": "no encontrado",
          "connected": "conectado"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Páginas",
          "all": "Todos los objetos de Pledge",
          "ships": "Naves",
          "components": "Módulos",
          "skins": "Pinturas",
          "upgrades": "Mejoras"
        },
        "importedItems": {
          "importedVehicles": "Naves agregadas",
          "foundVehicles": "Naves encontradas",
          "movedVehiclesToWanted": "Naves movidas a lista de deseos",
          "missingModels": "Naves no encontradas",
          "importedComponents": "Componentes agregados",
          "foundComponents": "Componentes encontrados",
          "missingComponents": "Componentes no encontrados",
          "missingComponentVehicles": "No se encontró nave coincidente para componentes",
          "importedUpgrades": "Mejoras agregadas",
          "foundUpgrades": "Mejoras encontradas",
          "missingUpgrades": "Mejoras no encontradas",
          "missingUpgradeVehicles": "No se encontró nave coincidente para mejoras",
          "new": "New",
          "updated": "Updated",
          "movedToWanted": "Moved to Wishlist",
          "missing": "Unable to Import"
        }
      },
      "cargoGridViewer": {
        "capacity": "Capacidad",
        "maxContainerSize": "Contenedor máx.",
        "packed": "Empaquetado",
        "totalCargo": "Carga total",
        "didNotFit": "No cabe",
        "openInTool": "Abrir en la herramienta de grilla de carga",
        "myHangar": "Mostrar solo mis naves",
        "filterShips": "Filtrar naves por tamaño de contenedor",
        "addShip": "Add Ship",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "admin": {
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Usuarios en línea",
            "totalUsers": "Usuarios totales",
            "totalShips": "Naves totales",
            "newShipsInYear": "Naves nuevas en %{year}",
            "totalFleets": "Flotas totales"
          }
        },
        "modelHardpoint": {
          "loadouts": "Configuraciones"
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "manual": "Manual"
          }
        },
        "resourceAccess": {
          "title": "Acceso a recursos",
          "groups": {
            "ship_data": "Datos de naves",
            "community": "Comunidad",
            "system": "Sistema"
          },
          "privileges": {
            "models": "Modelos",
            "model_modules": "Módulos de modelos",
            "components": "Componentes",
            "manufacturers": "Fabricantes",
            "vehicles": "Vehículos",
            "images": "Imágenes",
            "fleets": "Flotas",
            "users": "Usuarios",
            "supporters": "Patrocinadores",
            "admins": "Administradores",
            "oauth_applications": "Aplicaciones OAuth",
            "maintenance": "Mantenimiento",
            "imports": "Importaciones",
            "features": "Funciones",
            "workers": "Workers",
            "pghero": "PgHero",
            "rsi-api-status": "Estado de la API de RSI",
            "stats": "Estadísticas"
          }
        },
        "versions": {
          "blank": "vacío",
          "revertQuestion": "¿Revertir?",
          "sources": {
            "custom": "Admin",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "Archivos del juego",
            "sc_loader": "Archivos del juego",
            "uex_price_sync": "Sincronización de precios UEX",
            "unknown": "Desconocido"
          }
        }
      },
      "hangarTable": {
        "extraColumns": "Columnas",
        "columns": {
          "storeImage": "Imagen",
          "storeImageWide": "Imagen ancha",
          "angledView": "Imagen 3D",
          "angledViewWide": "Imagen 3D ancha",
          "modelManufacturerName": "Fabricante",
          "modelLength": "Longitud",
          "modelBeam": "Manga",
          "modelHeight": "Altura",
          "modelMass": "Masa",
          "modelCargo": "Carga",
          "modelMinCrew": "Tripulación",
          "modelMaxCrew": "Tripulación máx.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocidad máx.",
          "modelGroundMaxSpeed": "Velocidad terrestre",
          "modelFocus": "Enfoque",
          "modelProductionStatus": "Estado de producción",
          "modelPrice": "Precio",
          "modelPledgePrice": "Precio de Pledge"
        }
      },
      "fleetTable": {
        "extraColumns": "Columnas",
        "columns": {
          "storeImage": "Imagen",
          "storeImageWide": "Imagen ancha",
          "angledView": "Imagen 3D",
          "angledViewWide": "Imagen 3D ancha",
          "modelManufacturerName": "Fabricante",
          "modelLength": "Longitud",
          "modelBeam": "Manga",
          "modelHeight": "Altura",
          "modelMass": "Masa",
          "modelCargo": "Carga",
          "modelMinCrew": "Tripulación",
          "modelMaxCrew": "Tripulación máx.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocidad máx.",
          "modelGroundMaxSpeed": "Velocidad terrestre",
          "modelProductionStatus": "Estado de producción",
          "modelPrice": "Precio",
          "modelPledgePrice": "Precio de Pledge",
          "owner": "Propietario"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "inProgress": "in progress",
        "drafts": "drafts",
        "noInventories": "No inventories yet.",
        "noRequests": "No requests found.",
        "noItems": "No entries in this inventory.",
        "entriesCount": "entries",
        "comments": "comments",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "fulfilled": "Fulfilled",
        "itemFulfilled": "Fulfilled",
        "itemPending": "Pending",
        "requestTitle": "Title",
        "description": "Description",
        "requestType": "Type",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "approvedBy": "Approved by",
        "fulfilledBy": "Fulfilled by",
        "addComment": "Write a comment...",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "approved": "Approved",
          "in_progress": "In Progress",
          "fulfilled": "Fulfilled",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "supply": "Supply",
          "outfitting": "Outfitting",
          "general": "General"
        },
        "priorities": {
          "routine": "Routine",
          "standard": "Standard",
          "urgent": "Urgent",
          "critical": "Critical"
        },
        "searchInventories": "Search inventories...",
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityShort": "Quality",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "por encima de la capacidad de carga",
        "cargoGrid": "Rejilla de carga",
        "shipInventory": "Inventario de la nave",
        "remaining": "Restante",
        "unmeasured": "%{count} sin medir todavía"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "Bandeja de entrada",
        "archive": "Archivo",
        "unreadOnly": "Solo no leídas",
        "status": "Estado",
        "severity": "Gravedad",
        "type": "Tipo",
        "selectPrompt": "Selecciona una notificación para leerla",
        "noBody": "Esta notificación no incluye más detalles.",
        "lastSeen": "Vista por última vez",
        "expires": "Caduca",
        "severities": {
          "info": "Info",
          "warning": "Aviso",
          "error": "Error"
        },
        "types": {
          "paints_import": "Importación de pinturas",
          "modules_import": "Importación de módulos",
          "loaner_sync": "Sincronización de naves prestadas",
          "uex_prices_import": "Sincronización de precios UEX",
          "uex_commodity_prices_import": "Sincronización de materias primas UEX",
          "new_supporter": "Nuevo patrocinador",
          "rsi_api_blocked": "API de RSI bloqueada",
          "rsi_api_unblocked": "API de RSI restaurada",
          "weekly_stats": "Informe semanal",
          "ship_matrix_import": "Importación de Ship Matrix",
          "sc_data_import": "Importación de sc_data",
          "import_run": "Importación"
        }
      },
      "optional": "opcional",
      "notificationActions": {
        "open": "Abrir",
        "openHangar": "Abrir hangar",
        "openWishlist": "Abrir lista de deseos",
        "openModel": "Ver nave",
        "openInvite": "Ver invitación",
        "reviewRequest": "Revisar solicitud",
        "openMembers": "Ver miembros",
        "openFleet": "Abrir flota",
        "openInventory": "Abrir inventario",
        "openEvent": "Abrir evento",
        "openRoster": "Ver inscripciones",
        "addToCalendar": "Añadir al calendario",
        "openStore": "Tienda de pledges",
        "accept": "Aceptar",
        "decline": "Rechazar",
        "signUp": "Inscribirse",
        "withdraw": "Retirarse",
        "syncAgain": "Sincronizar de nuevo",
        "markAsBought": "Marcar como comprada",
        "unavailable": "Esto ya no está disponible."
      },
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "Correo",
          "push": "Push",
          "discord": "Discord"
        },
        "groups": {
          "account": "Cuenta y hangar",
          "fleetMembership": "Membresía de flota",
          "fleetEvents": "Eventos de flota"
        },
        "hangar_create": "Nave añadida al hangar",
        "hangar_destroy": "Nave eliminada del hangar",
        "hangar_sync_finished": "Sincronización del hangar finalizada",
        "hangar_sync_failed": "Sincronización del hangar fallida",
        "wishlist_create": "Añadida a la lista de deseos",
        "wishlist_destroy": "Eliminada de la lista de deseos",
        "model_on_sale": "Modelo en oferta",
        "new_model": "Nuevo modelo lanzado",
        "fleet_invite": "Invitación de flota recibida",
        "fleet_member_requested": "Membresía solicitada",
        "fleet_member_accepted": "Membresía aceptada",
        "fleet_request_accepted": "Solicitud de ingreso aceptada",
        "fleet_inventory_item_added": "Objeto añadido al inventario de la flota",
        "fleet_event_published": "Evento publicado",
        "fleet_event_locked": "Inscripciones del evento bloqueadas",
        "fleet_event_starting_soon": "El evento empieza pronto",
        "fleet_event_started": "Evento iniciado",
        "fleet_event_completed": "Evento completado",
        "fleet_event_cancelled": "Evento cancelado",
        "fleet_event_signup_added": "Nueva inscripción",
        "fleet_event_signup_withdrawn": "Inscripción retirada",
        "fleet_event_signup_confirmed": "Inscripción confirmada",
        "fleet_event_signup_assigned": "Asignado a un slot",
        "fleet_event_signup_kicked": "Eliminado de un slot",
        "allInGroup": "Todo en este grupo"
      },
      "fleets": {
        "missions": {
          "title": "Título",
          "description": "Descripción",
          "team": "Equipo",
          "teams": "Equipos",
          "ship": "Nave",
          "ships": "Naves",
          "slot": "Slot",
          "slots": "Slots",
          "noMissions": "Aún no hay misiones.",
          "noTeams": "Aún no se han añadido equipos.",
          "noShips": "Aún no se han añadido naves.",
          "noSlots": "Aún no se han añadido slots.",
          "archivedTab": "Archivadas",
          "activeTab": "Activas",
          "archived": "Archivada",
          "modelSpecific": "Nave específica",
          "modelList": "Cualquiera de estas",
          "modelListHint": "El puesto admite cualquiera de las naves que elijas.",
          "allowedShips": "Naves que encajan",
          "anyOf": "Cualquiera de",
          "filterRange": "Rango de filtro",
          "classification": "Clasificación",
          "focus": "Enfoque",
          "minSize": "Tamaño mín.",
          "maxSize": "Tamaño máx.",
          "minCrew": "Tripulación mín.",
          "minCrewOverride": "Anular",
          "minCrewOverrideLabel": "Anulación de tripulación mín.",
          "minCrewOverrideHint": "Déjalo vacío para usar la tripulación mínima por defecto de la nave.",
          "minCargo": "Carga mín. (SCU)",
          "shipFilters": "Filtros de naves",
          "createdBy": "Creada por",
          "seats": "Asientos",
          "category": "Categoría",
          "coverImage": "Imagen de portada",
          "coverPresets": "Elegir de los ejemplos",
          "scenario": "Escenario",
          "categories": {
            "other": "Otras",
            "ship_combat": "Combate de naves",
            "ground_combat": "Combate terrestre",
            "combined_combat": "Combate combinado",
            "mining": "Minería",
            "salvage": "Salvamento",
            "cargo_hauling": "Transporte de carga",
            "exploration": "Exploración"
          }
        },
        "events": {
          "title": "Título",
          "description": "Descripción",
          "briefing": "Briefing",
          "startsAt": "Empieza el",
          "endsAt": "Termina el",
          "timezone": "Zona horaria",
          "location": "Ubicación del evento",
          "meetupLocation": "Punto de encuentro",
          "visibility": "Visibilidad",
          "maxAttendees": "Asistentes máx.",
          "maxAttendeesValue": "Máx. %{count} asistentes",
          "autoLockEnabled": "Bloquear inscripciones automáticamente",
          "autoLockMinutesBefore": "Minutos antes del inicio para bloquear",
          "recurring": "Se repite",
          "recurringHint": "Genera este evento automáticamente con una periodicidad fija. Los miembros se inscriben en cada repetición.",
          "recurringSummary": "Se repite %{interval}",
          "recurringUntil": "Se repite %{interval} hasta %{date}",
          "recurringForCount": "Se repite %{interval} (%{count} repeticiones)",
          "viewSeries": "Ver serie",
          "recurrenceInterval": "Repetir cada",
          "recurrenceEnd": "Termina",
          "recurrenceEndNever": "Nunca",
          "recurrenceEndOn": "En una fecha",
          "recurrenceEndAfter": "Después de",
          "recurrenceEndOccurrences": "repeticiones",
          "recurrence": {
            "daily": "a diario",
            "weekly": "semanalmente",
            "biweekly": "cada dos semanas",
            "monthly": "mensualmente"
          },
          "occurrencesSection": "Próximas repeticiones",
          "skipOccurrence": "Omitir esta repetición",
          "overrideOccurrence": "Anular la repetición del %{date}",
          "overrideOccurrenceShort": "Editar solo esta",
          "overrideOccurrenceHint": "Anula campos solo para esta repetición. Déjalos en blanco para heredarlos del evento recurrente.",
          "endSeriesHere": "Detener a partir de aquí",
          "excludedBadge": "Omitida",
          "noUpcomingOccurrences": "No hay repeticiones próximas en las siguientes 12 semanas.",
          "endSeriesConfirm": "¿Detener la repetición después de esta fecha? No se generarán repeticiones futuras.",
          "skipOccurrenceSuccess": "Repetición omitida.",
          "endSeriesSuccess": "Serie finalizada a partir de esta fecha.",
          "cancelledReason": "Motivo de la cancelación",
          "noEvents": "Aún no hay eventos.",
          "noUpcoming": "No hay eventos próximos.",
          "noPast": "No hay eventos pasados.",
          "createdBy": "Creado por",
          "signups": "Inscripciones",
          "signupsCount": "%{count} inscripciones",
          "signupYou": "Tú",
          "youAreHere": "Estás aquí",
          "attendance": "Asistencia",
          "signupsLockedHint": "Las inscripciones están bloqueadas para este evento.",
          "noOverview": "Aún no hay descripción ni briefing.",
          "alreadySignedUpHint": "Ya estás inscrito en otro slot. Retírate primero para cambiar.",
          "slotTakenHint": "Este slot ya está ocupado.",
          "currentSlot": "Slot actual",
          "currentSlotHint": "Este es el slot en el que está actualmente la inscripción.",
          "takenBy": "Ocupado por %{username}",
          "slotPickerHint": "Elige un slot para esta inscripción. Los slots ya ocupados o no disponibles están deshabilitados.",
          "signupCtaHint": "Inscríbete en el evento — puedes elegir un slot concreto ahora o dejar que un administrador te asigne uno más tarde.",
          "noSlotYet": "Sin slot todavía",
          "signupApproval": "Aprobación de inscripciones",
          "signupApprovalInherit": "Heredar del evento",
          "signupStatuses": {
            "confirmed": "Confirmada",
            "tentative": "Tentativa",
            "interested": "Interesado",
            "pending": "Pendiente de aprobación",
            "withdrawn": "Retirada"
          },
          "signupApprovals": {
            "direct": "Directa",
            "confirmation_required": "Requiere confirmación"
          },
          "unassignedSignupsHint": "Estos miembros se inscribieron en el evento pero aún no tienen slot. Asígnales uno abajo o elimina la inscripción.",
          "taken": "Ocupado",
          "grantedRoles": "Roles concedidos",
          "noEventAdminsYet": "Aún no hay administradores ni moderadores adicionales.",
          "creator": "Creador del evento",
          "eventTeamHint": "Concede a otros miembros derechos de administrador o moderador para este evento. Los administradores pueden editarlo y los moderadores pueden gestionar las inscripciones.",
          "eventRole": "Rol",
          "eventRoles": {
            "admin": "Administrador",
            "moderator": "Moderador"
          },
          "memberPicker": "Miembro",
          "spawnedFromMission": "Generado desde la misión",
          "spawnedEvents": "Eventos generados",
          "fromMission": "De la misión",
          "pickTemplate": "Elegir una plantilla",
          "pickTemplateHint": "Opcionalmente, parte de una plantilla de misión — los campos se rellenarán previamente y el evento quedará vinculado a ella.",
          "noTemplate": "Sin plantilla",
          "noTemplateHint": "Crea el evento desde cero.",
          "changeTemplate": "Cambiar plantilla",
          "clearTemplate": "Quitar plantilla",
          "freeSlot": "Slot libre",
          "myVehicle": "Mi vehículo",
          "selectVehicle": "Seleccionar un vehículo (opcional)",
          "vehicleMismatchHint": "El vehículo seleccionado no cumple los requisitos de este slot.",
          "noFittingInHangar": "Nada de tu hangar encaja en este slot. Aun así puedes inscribirte dejando el vehículo vacío.",
          "vehicleFitsHint": "Aporta un vehículo que encaja con esta nave.",
          "noMatchingVehicle": "Ninguna inscripción aporta un vehículo que encaje.",
          "shipNotCrewedYet": "Aún no hay ninguna inscripción que encaje.",
          "expandHint": "%{model} tiene %{count} asiento(s) más. ¿Añadir slots para que otros los ocupen?",
          "notes": "Notas",
          "upcomingTab": "Próximos",
          "pastTab": "Pasados",
          "archivedTab": "Archivados",
          "listTab": "Lista",
          "calendarTab": "Calendario",
          "openInCalendar": "Suscribirse (.ics)",
          "openInCalendarHint": "Añade esta URL a tu aplicación de calendario para mantener los eventos sincronizados.",
          "rotateFeedToken": "Rotar el enlace del feed",
          "subscribeHint": "Copia la URL del feed del calendario a tu portapapeles para que puedas pegarla en tu aplicación de calendario.",
          "visibilities": {
            "members": "Miembros",
            "officers": "Oficiales",
            "fleet": "Público"
          },
          "statuses": {
            "draft": "Borrador",
            "open": "Abierto a inscripciones",
            "locked": "Inscripciones bloqueadas",
            "active": "En directo",
            "completed": "Completado",
            "cancelled": "Cancelado",
            "past": "Pasado"
          },
          "tabs": {
            "basic": "Información básica",
            "description": "Descripción y portada",
            "teams": "Equipos y naves",
            "overview": "Resumen",
            "settings": "Ajustes"
          },
          "calendar": {
            "month": "Mes",
            "week": "Semana",
            "weekTitle": "Semana del %{date}"
          },
          "repeats": "Se repite"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "slot": "Slot",
        "size": "Size",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "notifications": {
        "inbox": "Bandeja de entrada",
        "archive": "Archivo",
        "unreadOnly": "Solo no leídas",
        "status": "Estado",
        "type": "Tipo",
        "selectPrompt": "Selecciona una notificación para leerla",
        "noBody": "Esta notificación no incluye más detalles.",
        "archivesOn": "Se mueve al archivo",
        "deletesOn": "Se elimina"
      },
      "unlistedModel": {
        "linkHint": "¿Qué nave del catálogo es %{identifier}? La sugerencia viene del export y puede estar equivocada."
      },
      "slug": "Slug",
      "inventories": {
        "source": "Fuente",
        "sources": {
          "vehicle": "Nave",
          "handMade": "Creado a mano"
        }
      },
      "inventoryItems": {
        "name": "Nombre",
        "category": "Categoría",
        "entryType": "Movimiento",
        "quantity": "Cantidad",
        "quality": "Calidad",
        "notes": "Notas",
        "itemType": "Catálogo",
        "categories": {
          "commodity": "Mercancía",
          "component": "Componente",
          "weapon": "Arma",
          "equipment": "Equipamiento",
          "ammunition": "Munición",
          "consumable": "Consumible",
          "other": "Otros"
        },
        "entryTypes": {
          "deposit": "Depósito",
          "withdrawal": "Retirada"
        },
        "units": {
          "scu": "SCU",
          "units": "unidades"
        }
      },
      "scDataSource": {
        "dataSource": "Fuente de datos",
        "notLive": "No es la compilación live"
      },
      "erkul": {
        "prefix": "Tryout Loadouts with",
        "link": "Erkul's DPS Calculator"
      }
    }
  }
}
